import { render, staticRenderFns } from "./payments.vue?vue&type=template&id=09acbe31&scoped=true"
import script from "./payments.vue?vue&type=script&lang=js"
export * from "./payments.vue?vue&type=script&lang=js"
import style0 from "./payments.vue?vue&type=style&index=0&id=09acbe31&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09acbe31",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/kra/payments.vue
// module id = e5tI
// module chunks = 0